import React, { useContext } from "react";
import Menu from './components/Templates/Site/Menu';
import { BrowserRouter } from "react-router-dom";
import Router from "./pages/routers/Router";
import { useSelector } from 'react-redux';
import { __enum_SystemPages, __HeaderImageStyles, __SystemPagesPaths } from './common/Dictionaries';
import MainAppContext from "./MainAppContext";

function Layout(props) {
    const contextSite = useContext(MainAppContext);

    const { token: currentAuth } = useSelector((state) => state.auth);

    const profiles = currentAuth.token.profile
    const pageIsHomeLanding = props.pageIsHomeLanding
    
    const currentDate = new Date();
    const currentDateSeconds = currentDate.getSeconds();
    const secondsPerHeaderImage = 60 / __HeaderImageStyles.length;
    const styleHeader = __HeaderImageStyles[Math.floor(currentDateSeconds / secondsPerHeaderImage)];

    const isMantainerPage = window.location.href.toLowerCase().indexOf('/forms/') !== -1;

    return (
        <BrowserRouter>
        {
            currentAuth &&
            <>
                {
                    window.location.href.toLowerCase().indexOf(__SystemPagesPaths[__enum_SystemPages.Logout].text.toLowerCase()) === -1 &&
                    <div className="bg-image position-absolute" style={styleHeader}></div>
                }
                <Menu />
                
                <div className={(isMantainerPage ? "h-100" : "")} style={ { paddingLeft: (!pageIsHomeLanding ? "10px": ""), paddingRight: (!pageIsHomeLanding ? "10px": ""), paddingTop: (!pageIsHomeLanding ? "160px": "160px")}}>
                    <Router products={ contextSite.securityProps.l_products } profiles={ profiles } />
                </div>
            </>
        }
        </BrowserRouter>
    );
}

export default Layout;